import { useTranslation } from 'react-i18next'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

export default function BonusControl () {
  const { t } = useTranslation('info')

  const cards = t('bonusControl.cards', { returnObjects: true })

  return (
    <div className={styles.root}>
      {Object.entries(cards).map(([ key, card ], index) => (
        <div key={key} className={cn(styles.root__item)}>
          <p>{card.text}</p>
          <img
            className={styles.root__img}
            src={`img/bonus-control/${index + 1}.png`}
            alt=""
          />
        </div>
      ))}
    </div>
  )
}
